import {AuthenticatedTemplate} from '@azure/msal-react'
import {useMsal} from '@azure/msal-react'
import {Container} from 'react-bootstrap'
import {ApplicationRole} from '../store/applicationRole'

export const HomePage = () => {
  const {instance} = useMsal()
  const activeAccount = instance.getActiveAccount()

  return (
    <>
      <AuthenticatedTemplate>
        {activeAccount ? (
          <Container
            fluid={true}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: `0rem calc( 5% - 1rem)`,
            }}>
            <ApplicationRole />
          </Container>
        ) : null}
      </AuthenticatedTemplate>
    </>
  )
}
